export default __webpack_public_path__ + "static/roland.teissl-3309678b33280c4d5cfc766e20a57eb0.png";